<script>
	import HeaderMenuItem from './HeaderMenuItem.svelte';
	import { email, phone } from './images/icons.svelte';
</script>

<HeaderMenuItem position="full" transparent>
	{#snippet title()}
		<div class="menu-button focus-off pointer-events-none w-6"></div>
		<div class="menu-close focus-on pointer-events-none hidden w-6"></div>
	{/snippet}
	<ul class=" bg-indow-white list-none px-8 pt-8 pb-12">
		<li class="m-0">
			<a
				class="text-indow-blue m-0 block w-full py-2 text-2xl font-bold no-underline"
				href="/solutions/window-insulation"
			>
				SOLUTIONS
			</a>
		</li>
		<li class="m-0">
			<a
				class="text-indow-blue m-0 block w-full py-2 text-2xl font-bold no-underline"
				href="/products/indowone-window-inserts"
			>
				PRODUCTS
			</a>
		</li>
		<li class="m-0">
			<a
				class="text-indow-blue block w-full py-2 text-2xl font-bold no-underline"
				href="/how-to"
			>
				HOW TO
			</a>
		</li>
		<li class="m-0">
			<a
				class="text-indow-blue block w-full py-2 text-2xl font-bold no-underline"
				href="/products/window-insert-cost"
			>
				PRICING
			</a>
		</li>
		<li class="mb-10">
			<a
				class="text-indow-blue block w-full py-2 text-2xl font-bold no-underline"
				href="/about-indow"
			>
				ABOUT US
			</a>
		</li>
		<li>
			<p class="text-indow-grey text-2xl font-bold">CONTACT</p>
		</li>
		<li class="m-0">
			<a
				class="text-indow-blue flex w-full items-center gap-4 py-2 text-lg no-underline"
				href="tel:+15032842260"
			>
				<span class="inline-block w-8">
					{@render phone()}
				</span>

				+1 (503) 284-2260</a
			>
		</li>
		<li class="m-0">
			<a
				class="text-indow-blue flex w-full items-center gap-4 py-2 text-lg no-underline"
				href="mailto:comfort@indowwindows.com"
			>
				<span class="inline-block w-8">
					{@render email()}
				</span>
				comfort@indowwindows.com</a
			>
		</li>
	</ul>
</HeaderMenuItem>

<style class="postcss">
	.menu-button {
		&:not(:focus-within)::before {
			content: '';
			display: block;
			height: 10px;
			border-top: 2px solid white;
			border-bottom: 2px solid white;
		}
		&:not(:focus-within)::after {
			content: '';
			display: block;
			height: 8px;
			border-bottom: 2px solid white;
		}
	}
	.menu-close {
		&:not(:focus-within)::before {
			content: '';
			display: block;
			height: 1px;
			background-color: var(--color-indow-white);
			rotate: 45deg;
			border: solid white 2px;
			border-radius: 3px;
		}
		&:not(:focus-within)::after {
			content: '';
			display: block;
			height: 1px;
			background-color: var(--color-indow-white);
			border: solid white 2px;
			margin-top: -4px;
			rotate: -45deg;
			border-radius: 3px;
		}
	}
</style>
